import { useSelectedOrgId } from "@fero/hooks";
import { useQuery } from "@tanstack/react-query";
import { makeProductSearchQueryReq } from "adl-gen/ferovinum/app/api";
import { assertNotUndefined } from "utils/hx/util/types";
import { useAppService } from "../../use-app-service";
import { productKeys } from "../query-keys";

export const MINIMUM_SEARCH_TERM_LENGTH = 3;

export const useProductSearchQuery = (searchTerm: string) => {
  const service = useAppService();
  const organisationId = assertNotUndefined(useSelectedOrgId());

  return useQuery({
    queryKey: productKeys.productSearch(organisationId, searchTerm),
    queryFn: () =>
      service.productSearch(
        makeProductSearchQueryReq({ organisationId, searchTerm }),
      ),
    enabled: searchTerm.length >= MINIMUM_SEARCH_TERM_LENGTH,
  });
};
